module.exports = __webpack_public_path__ + "media/application/images/icons/home-09576b21a016cc4fb7f5dcf30359f9c3.svg";